export default __webpack_public_path__ + "static/media/reward_goods.24e02a36.png";